<script>
export default {
  data: () => ({
    show: false,
  }),
  methods: {
    order() {
      this.$router.push("/");
    },
    //push
    linkStep1() {
      this.$router.push("/users/step1");
    },
    linkStep2() {
      this.$router.push("/users/step2");
    },
    linkStep3() {
      this.$router.push("/users/step3");
    },
    linkStep4() {
      this.$router.push("/users/step4");
    },
    linkStep5() {
      this.$router.push("/users/step5");
    },
    linkStep6() {
      this.$router.push("/users/step6");
    },
    linkStep7() {
      this.$router.push("/users/step7");
    },
  },
};
</script>
<template>
  <div id="step7">
    <!-- Jumbotron -->
    <header class="d-flex justify-content-center align-items-center">
      <div class="text-center">
        <div class="card alpha-50">
          <div class="card-body">
            <el-steps :active="6" simple>
              <el-step
                @click="linkStep1"
                title="網路掛號"
                icon="el-icon-s-custom"
              ></el-step>
              <el-step
                @click="linkStep3"
                title="至各診間候診"
                icon="el-icon-loading"
              ></el-step>
              <el-step
                @click="linkStep4"
                title="檢查、抽血"
                icon="el-icon-search"
              ></el-step>
              <el-step
                @click="linkStep5"
                title="櫃台批價"
                icon="el-icon-printer"
              ></el-step>
              <el-step
                @click="linkStep6"
                title="藥局領藥"
                icon="el-icon-sugar"
              ></el-step>
              <el-step
                @click="linkStep7"
                title="離院"
                icon="el-icon-school"
              ></el-step>
            </el-steps>
          </div>
        </div>
      </div>
    </header>
    <h1 class="pt-5 py-3">準備離院</h1>
    <h3 class="pt-5 py-3 animate__animated animate__shakeY">
      恭喜<strong>{{ $store.state.name }}</strong>
      先生/小姐 順利完成看診，可以準備出院囉~
    </h3>
    <div class="py-5">
      <el-button @click="show = !show">手續已辦妥</el-button>
      <div style="margin-top: 20px; height: 100px">
        <transition name="el-fade-in-linear">
          <div v-show="show" class="transition-box">
            <el-button type="primary" @click="order">回首頁</el-button>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="@/assets/scss/step3.scss" scoped>
#step7 {
}
</style>
